export default __webpack_public_path__ + "static/media/worker.44e04004.jpg";